import React, { useState } from 'react';
import { siteContent } from '../data/mock';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// GA4 event tracking helper
const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

const ClosingCTA = ({ formRef }) => {
  const { closing } = siteContent;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/demo-request`, {
        name: formData.name,
        company: formData.company,
        email: formData.email,
        message: formData.message || null
      });

      if (response.data.success) {
        // Track successful form submission in GA4
        trackEvent('form_submission', {
          form_name: 'demo_request',
          form_location: 'landing_page_cta'
        });

        setSubmitStatus({ type: 'success', message: response.data.message });
        setFormData({ name: '', email: '', company: '', message: '' });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Something went wrong. Please try again.';
      setSubmitStatus({ type: 'error', message: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section ref={formRef} className="py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl mx-auto">
        <p className="text-xl md:text-2xl text-neutral-700 leading-relaxed mb-16 text-center">
          {closing.body}
        </p>
        
        <div className="max-w-md mx-auto">
          <h3 className="text-2xl font-medium text-neutral-900 mb-8 text-center">
            {closing.cta}
          </h3>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="name" className="text-sm text-neutral-700 mb-2 block">
                Name
              </Label>
              <Input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full border-neutral-300 focus:border-neutral-500 focus:ring-neutral-500"
              />
            </div>
            
            <div>
              <Label htmlFor="company" className="text-sm text-neutral-700 mb-2 block">
                Company
              </Label>
              <Input
                id="company"
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                required
                className="w-full border-neutral-300 focus:border-neutral-500 focus:ring-neutral-500"
              />
            </div>
            
            <div>
              <Label htmlFor="email" className="text-sm text-neutral-700 mb-2 block">
                Email
              </Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full border-neutral-300 focus:border-neutral-500 focus:ring-neutral-500"
              />
            </div>
            
            <div>
              <Label htmlFor="message" className="text-sm text-neutral-700 mb-2 block">
                Message (optional)
              </Label>
              <Textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="w-full border-neutral-300 focus:border-neutral-500 focus:ring-neutral-500 resize-none"
              />
            </div>
            
            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-neutral-900 text-white hover:bg-neutral-800 py-6 text-base rounded-md disabled:opacity-50"
            >
              {isSubmitting ? 'Sending...' : 'Send request'}
            </Button>
            
            {submitStatus && (
              <p className={`text-center text-sm ${
                submitStatus.type === 'success' ? 'text-neutral-700' : 'text-red-600'
              }`}>
                {submitStatus.message}
              </p>
            )}
          </form>
        </div>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
